<template lang="pug">
    v-form.c-form(autocomplete="off")
        v-container(fluid grid-list-lg)

            // Program form fields
            program-form(ref="form")

            // Meditations draggable list
            meditations-list

            v-layout.align-center(raw wrap)
                v-flex(xs12)

                    // Horizontal line
                    separator-component

                v-flex(xs6)

                    // Emails title
                    title-component(
                        type="h5"
                        :title="$t('programs.create.subtitle')"
                    )

                v-flex(xs6)

                    // Email form Modal window
                    email-component(roteName="program")


                v-flex(xs12)

                    emails-list

            v-layout(raw wrap)
                v-flex(xs12)

                    // Horizontal line
                    separator-component

                    div.controls
                        div

                            // Cancel button
                            button-component.ml-0(
                                :action="cancel"
                                :isLoading="isLoading"
                                :disabled="isLoading"
                                color="grey"
                                large
                                outline
                            ) {{ $t('defaultButtons.cancel') }}

                        div

                            // Submit button
                            button-component.mr-0.submit(
                                :action="submit"
                                :isLoading="isLoading"
                                :disabled="isLoading"
                                color="primary"
                                large
                            ) {{ submitButtonText }}

</template>

<script>
    import VueTypes from 'vue-types';
    import ProgramForm from './ProgramForm';
    import meditationsList from './meditationsList';
    import Button from '~components/Button';
    import Separator from '~components/Separator';
    import Title from '~components/Title';
    import EmailForm from '~components/EmailForm';
    import { mapFields } from 'vuex-map-fields';
    import { mapActions, mapGetters } from 'vuex';
    import EmailsList from './emailsList';

    export default {
        components: {
            EmailsList,
            ProgramForm,
            meditationsList,
            ButtonComponent: Button,
            SeparatorComponent: Separator,
            EmailComponent: EmailForm,
            TitleComponent: Title
        },
        props: {
            action: VueTypes.string.def('create')
        },
        computed: {
            ...mapFields('programs', {
                model: 'program'
            }),
            ...mapGetters('programs', ['isLoading']),
            ...mapGetters('sessions', ['sessions']),

            /**
             * Submit button text
             *  @returns {string}
             */
            submitButtonText() {
                if (this.action === 'create') {
                    return this.$t('defaultButtons.save');
                }

                return this.$t('defaultButtons.update');
            }
        },
        beforeMount() {
            this.resetProgram();
        },
        methods: {
            ...mapActions('programs', [
                'create',
                'update',
                'cancel',
                'resetProgram'
            ]),

            /**
             * Create Business account on submit
             * @returns {boolean}
             */
            async submit() {
                // Validate all fields and check in no errors

                const validation = await this.$refs.form.submit();

                if (!validation) return;

                // Call store action Create Program
                if (this.action === 'create') {
                    return this.create();
                }

                // Call store action Update Program if action not `create`
                return this.update();
            }
        }
    };
</script>
